exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listViewDivider_1doZDtbTJ-qEgqm_qcpRWI {\n  width: 100%;\n  height: 1px;\n  background-color: #eeeeee;\n  float: left;\n}\n\n.IA_noGroups_2Syg09TUCk3sYn2NjQ9gtx {\n  width: 100%;\n  text-align: center;\n  height: 50px;\n  background-color: #f5f5f5;\n  line-height: 50px;\n  font-size: 12px;\n  color: #999;\n  font-weight: 300;\n}", ""]);

// Exports
exports.locals = {
	"IA_listViewDivider": "IA_listViewDivider_1doZDtbTJ-qEgqm_qcpRWI",
	"IA_noGroups": "IA_noGroups_2Syg09TUCk3sYn2NjQ9gtx"
};